var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoicon = function SvgInfoicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0.5 16 16.5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 8.757a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm1.6 0a6.4 6.4 0 1 0 12.8 0 6.4 6.4 0 0 0-12.8 0Zm7.2.4a.4.4 0 0 0-.4-.4h-.8a.4.4 0 0 0-.4.4v2.4c0 .221.18.4.4.4h.8a.4.4 0 0 0 .4-.4v-2.4Zm-.4-3.6c.22 0 .4.18.4.4v.8a.4.4 0 0 1-.4.4h-.8a.4.4 0 0 1-.4-.4v-.8c0-.22.18-.4.4-.4h.8Z",
    clipRule: "evenodd"
  })));
};
export default SvgInfoicon;